module.exports = __webpack_public_path__ + "img/375_stores_img1.ddc8775b.png";